import { render } from "./InternalErrorPage.vue?vue&type=template&id=4eb9d27c&ts=true"
import script from "./InternalErrorPage.vue?vue&type=script&lang=ts"
export * from "./InternalErrorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__